module.exports = __webpack_public_path__ + "static/media/client-connect.753c022f.png";